import { useHistory } from 'react-router-dom';
import Pfooter from '../Pfooter';
import '../App.css';
import './Login.css';
import { useState } from 'react';
import { toast } from 'react-toastify';
import ApiHandler from '../ApiHandler';
import { userActions } from '../store/user-slice';
import { useDispatch } from 'react-redux';
import ClientSelect from '../components/ClientSelect';
import LoginHeader from './LoginHeader';
import BranchSwitch from './BranchSwitch';


export default function Company() {
    const [data, setData] = useState({ username: "", password: "", });
    const [clientId, setClientId] = useState("");
    const dispatch = useDispatch();


    const changeHandler = (e) => {
        setData({ ...data, [e.target.name]: e.target.value })
    }

    const history = useHistory();

    async function checkUser(e) {

        e.preventDefault();

        if (!clientId) {
            toast.error("Please select a firm");
            return;
        }

        // A rep signs in against the firm they picked, not the customer default.
        let item = {
            userId: data.username,
            password: data.password,
            wclientid: clientId,

        };
        // let token="";


        ApiHandler.post({
            url: "/api/Com/Authenticate/AuthTokenCom/",
            data: item,

        }
        )
            .then(((result) => {
                console.log(result.data.token)
                if (result.data.isSuccess) {
                    // Save the session BEFORE navigating: the dashboard reads it on
                    // its first render, and "app-type" still held "Cust" from any
                    // earlier customer login until this ran.
                    localStorage.setItem('user-info', JSON.stringify(result.data))
                    localStorage.setItem("app-type", "Com");
                    dispatch(userActions.setLogin(true));
                    history.push("/components/company/CompanyDashboard")
                }
                else {
                    throw result.data;
                }


            }))
            .catch(err => {
                toast.error("wrong username or password");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                    //   RefreshTokenHandler();
                    //  ToastError("Token has expired Please refresh");
                }
            })





    }
    return (
        <div className="loginShell">
            <LoginHeader />

            <div className='loginPage'>
                <form onSubmit={checkUser} className='w-100'>
                    <div className='row m-0'>
                        <div className='col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 p-3'>
                            <div className='loginCard loginCardMain'>
                                <div className='loginBranchRibbon'>UDUPI HEAD BRANCH</div>
                                <BranchSwitch type='Company' active='main' />
                                <div className='loginCardHead'>
                                    <h5 className='loginCardTitle'>Company Login</h5>
                                    <p className='loginCardSub'>Sign in with your rep ID</p>
                                </div>
                                <div className='loginCardBody'>

                                    <ClientSelect onReady={setClientId} />

                                    <label htmlFor='username'>Rep Id</label>
                                    <input
                                        id='username'
                                        name="username"
                                        className='form-control'
                                        onChange={changeHandler}
                                        value={data.username}
                                        type="text"
                                        autoComplete='username'
                                        placeholder='Enter your rep ID' />

                                    <label htmlFor='password'>Password</label>
                                    <input
                                        id='password'
                                        onChange={changeHandler}
                                        className='form-control'
                                        name="password"
                                        value={data.password}
                                        type="password"
                                        autoComplete='current-password'
                                        placeholder='Enter your password' />

                                    <button
                                        type="submit"
                                        className='loginBtn'
                                        disabled={!clientId}
                                    >Sign In</button>

                                    <p className='loginHint'>
                                        {clientId
                                            ? 'Reports will open for the firm selected above.'
                                            : 'Select a firm to continue.'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Pfooter />
        </div>
    )
}